<template>
  <div class="mx-auto max-w-lg">
    <template v-if="groupedQuotes.valueProps">
      <MobileProviderLabel
        v-for="valueProp in groupedQuotes.valueProps"
        :key="valueProp"
        class="mt-3"
        type="good"
        :provider="groupedQuotes.psp"
        :message-key="`provider_messages:${valueProp}`"
      />
    </template>

    <template v-if="groupedQuotes.customMessages.information">
      <MobileProviderLabel
        v-for="infoMessage in groupedQuotes.customMessages.information"
        :key="infoMessage"
        class="mt-3"
        type="info"
        :provider="groupedQuotes.psp"
        :message-key="`provider_messages:${infoMessage}`"
      />
    </template>

    <template v-if="groupedQuotes.customMessages.caution">
      <MobileProviderLabel
        v-for="cautionMessage in groupedQuotes.customMessages.caution"
        :key="cautionMessage"
        class="mt-3"
        type="caution"
        :provider="groupedQuotes.psp"
        :message-key="`provider_messages:${cautionMessage}`"
      />
    </template>

    <MobileProviderLabel
      v-if="!isSupportedLang"
      class="mt-3"
      type="caution"
      :provider="groupedQuotes.psp"
      :message-key="'transfer_comparison.not_available_in_language'"
      :details-text="availableInLanguages"
    />

    <template v-if="groupedQuotes.customMessages.warning">
      <MobileProviderLabel
        v-for="warningMessage in groupedQuotes.customMessages.warning"
        :key="warningMessage"
        class="mt-3"
        type="warning"
        :provider="groupedQuotes.psp"
        :message-key="`provider_messages:${warningMessage}`"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { GroupedQuotes } from '../types'
import MobileProviderLabel from './mobile-provider-label.vue'

const props = defineProps<{ groupedQuotes: GroupedQuotes }>()

const { $lang, $t } = useNuxtApp()

const isSupportedLang = computed(() =>
  props.groupedQuotes.psp.languages.some((l) => l.code === $lang),
)

const availableInLanguages = computed(() => {
  if (isSupportedLang.value) return ''
  return $t('transfer_comparison.available_in_languages', {
    provider: props.groupedQuotes.psp.displayName,
    languages: props.groupedQuotes.psp.languages.map((l) => l.label).join(', '),
    count: props.groupedQuotes.psp.languages.length,
  })
})
</script>
